import $ from 'jquery';
import Slideshow from 'app/generic/slideshow/SlideshowCollection';


var
	SELECTOR_SLIDESHOW = '.slideshow:first',
	BREAKPOINT = 1024
;


class View extends Slideshow {

	constructor(options) {
		var
			element = $(options.el || options.$el),
			windowWidth = window.innerWidth || $(window).width(),
			elementWidth = element.width(),
			settings = {
				adaptiveHeight: true,
				arrows: true,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: BREAKPOINT,
						settings: 'unslick'
					},
					{
						breakpoint: 700,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 2
						}
					}
				],
			}
		;

		// Handle slideshow inside small containers
		if (elementWidth < BREAKPOINT && windowWidth > BREAKPOINT) {
			delete settings.responsive[0];

			if (elementWidth < 480) {
				settings.responsive.push(
					{
						breakpoint: 900,
						settings: {
							slidesToShow: 1
						}
					}
				);
			}
		}

		super($.extend(true, {
			selector: SELECTOR_SLIDESHOW,
			settings: settings,
			breakpoint: BREAKPOINT
		}, options));
	}

}

export default View;
